import React, { Fragment } from 'react';
import { HorizontalTextRuler, TabChangeButton, VerticalTextRuler } from '@tencent/docs-scenario-component-text-ruler';
import styles from './index.less';
import { IParagraphManager } from '@src/slide/application/service/paragraph-manager/core/paragraph-manager.interface';
import {
    IRulerInfo,
    ITextRulerManager,
    ITextRulerProps,
} from '@src/slide/application/service/text-ruler-manager/core/index.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { RegionType } from '@src/slide/domain/selection/constant/region';

/**
 * 标尺
 */
export default class TextRuler extends React.Component<ITextRulerProps> {
    private textRulerManager?: ITextRulerManager;
    private paragraphManager?: IParagraphManager;


    constructor(props: ITextRulerProps) {
        super(props);
        this.textRulerManager = props.textRulerManager;
        this.paragraphManager = props.textRulerManager?.paragraphManager;
    }

    public componentDidMount() {
        this.textRulerManager?.componentDidMount({
            callback: () => {
                this.forceUpdate();
            },
        });
    }

    public componentWillUnmount() {
        this.textRulerManager?.componentWillUnmount();
    }

    public updateComponentWhenIsEditing = () => {
        const isEditing = this.textRulerManager?.editorInstanceService.checkEditorIsEditing();
        if (isEditing) {
            this.forceUpdate();
        }
    };

    render() {
        // 初始化标尺信息
        this.resetRulerSize();
        let isEditing = !!this.textRulerManager?.editorInstanceService.checkEditorIsEditing();
        const { selectedElements, lastMouseDownRegion } = this.textRulerManager?.selectionService || { };
        const selectedModel = selectedElements?.getCurrentModel();
        // 暂时屏蔽chart
        if (selectedModel.type === UIModelType.CHART) {
            isEditing = false;
        }

        // 备注与无选中没有编辑态标尺
        if ((selectedModel.type === UIModelType.NOTE || lastMouseDownRegion === RegionType.NOTE)
            || selectedModel.type === UIModelType.EMPTY) {
            isEditing = false;
        }

        // 数据格式化到通用比例，slide之前为了处理小字体，所有scale都是 / 2处理的，接入sc时，需要格式化回来
        const rulerScale = this.props.scale * 2;
        this.initAndFormatRulerSizeWithRealScale({
            slideLeft: this.props.slideLeft,
            slideWidth: this.props.slideWidth,
            slideTop: this.props.slideTop,
            slideHeight: this.props.slideHeight,
            scale: this.props.scale,
        });

        // 计算编辑态标尺信息
        if (isEditing) {
            this.computeEditingRulerSize(selectedModel, this.props.scale);
        }

        return (
            this.textRulerManager?.displayRuler && <Fragment>
                {/* 粘性定位 */}
                <div
                    onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    className={styles.horizontalTextRulerContainer}>
                    <div
                        className={styles.horizontalTextRulerInnerContainer}
                        onDoubleClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                        style={{
                            width: this.props.containerWidth,
                        }}
                    >
                        {/* 水平标尺 */}
                        <HorizontalTextRuler
                            useGuide={true}
                            isRevert={this.textRulerManager.isRevert}
                            showIndentControl={this.textRulerManager.isControlInHori}
                            indentLeft={this.textRulerManager.indentLeft}
                            marginLeft={this.textRulerManager.marginLeft}
                            rulerWidth={this.textRulerManager.rulerWidth}
                            rulerLeft={this.textRulerManager.rulerLeft}
                            scale={rulerScale}
                            isEditing={isEditing}
                            editingRenderLeft={this.textRulerManager.editAreaLeft}
                            editingRenderWidth={this.textRulerManager.editAreaWidth}
                            tabList={this.textRulerManager.tabList}
                            defaultAlignment={this.textRulerManager?.defaultAlignment}
                            isOpenIndentRight={false}
                            isLimitEditArea={true}
                            minIndentSpace={1.5}
                            defaultTabs={this.textRulerManager.defaultTabs}
                            useTab={true}
                            onIndentLeftChangeEnd={this.textRulerManager?.updateIndentLeft}
                            onMarginLeftChangeEnd={this.textRulerManager?.updateMarginLeft}
                            onMarginLeftAndIndentLeftChangeEnd={this.textRulerManager?.updateMarginLeftAndIndentLeft}
                            onTabChangeEnd={this.textRulerManager?.updateTabList}
                            onTabDoubleClick={() => {
                                this.paragraphManager?.showParagraph({
                                    isTabstopModalVisible: true,
                                });
                            }}
                            onIndentDoubleClick={() => this.paragraphManager?.showParagraph()}
                        /></div>
                </div>
                <div
                    onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    className={styles.verticalTextRulerContainer}>
                    <div
                        className={styles.verticalTextRulerInnerContainer}
                        onDoubleClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                        style={{
                            height: this.props.containerHeight,
                        }}
                    >
                        {/* 垂直标尺 */}
                        <VerticalTextRuler
                            useGuide={true}
                            isRevert={this.textRulerManager.isRevert}
                            showIndentControl={!this.textRulerManager.isControlInHori}
                            indentLeft={this.textRulerManager.indentLeft}
                            marginLeft={this.textRulerManager.marginLeft}
                            rulerHeight={this.textRulerManager.rulerHeight}
                            rulerTop={this.textRulerManager.rulerTop}
                            scale={rulerScale}
                            isEditing={isEditing}
                            editingRenderTop={this.textRulerManager.editAreaTop}
                            editingRenderHeight={this.textRulerManager.editAreaHeight}
                            tabList={this.textRulerManager.tabList}
                            defaultAlignment={this.textRulerManager?.defaultAlignment}
                            isOpenIndentRight={false}
                            isLimitEditArea={true}
                            minIndentSpace={1.5}
                            defaultTabs={this.textRulerManager.defaultTabs}
                            useTab={true}
                            onIndentLeftChangeEnd={this.textRulerManager?.updateIndentLeft}
                            onMarginLeftChangeEnd={this.textRulerManager?.updateMarginLeft}
                            onMarginLeftAndIndentLeftChangeEnd={this.textRulerManager?.updateMarginLeftAndIndentLeft}
                            onTabChangeEnd={this.textRulerManager?.updateTabList}
                            onTabDoubleClick={() => {
                                this.paragraphManager?.showParagraph({
                                    isTabstopModalVisible: true,
                                });
                            }}
                            onIndentDoubleClick={() => this.paragraphManager?.showParagraph()}
                        />
                    </div>
                </div>
                {/* 制表符对齐 */}
                <div
                    className={styles.changeTabButtonContainer}>
                    <TabChangeButton
                        isEditing={isEditing}
                        onChangeDefaultTab={this.textRulerManager?.updateDefaultAlignment} />
                </div>
            </Fragment>
        );
    }

    /**
     * 计算编辑态下，标尺、按钮、编辑区的尺寸信息
     * @param selectedModel
     * @private
     */
    private computeEditingRulerSize(selectedModel, scale: number) {
        this.textRulerManager?.computeEditingRulerSize(selectedModel, scale);
    }

    /**
     * 格式化slide的2倍尺寸计算
     * @private
     */
    private initAndFormatRulerSizeWithRealScale(info: IRulerInfo) {
        this.textRulerManager?.initAndFormatRulerSizeWithRealScale(info);
    }

    /**
     * 重置数据
     * @private
     */
    private resetRulerSize() {
        this.textRulerManager?.resetRulerSize();
    }
}
